import {
  IconButton as ChakraIconButton,
  IconButtonProps as ChakraIconButtonProps,
} from '@chakra-ui/react';

/**
 * Кнопка без текста, поэтому подпись обязательна на уровне типа: без неё читалка зовёт «⋮»
 * просто «кнопкой» (так было у меню профиля и комментария). Раньше имя было необязательным, и
 * каждое новое место могло его забыть молча. Если подпись приходит через `labelledby`, её тоже
 * надо назвать явно.
 */
type IconButtonProps = Omit<ChakraIconButtonProps, 'aria-label'> & {
  'aria-label': string;
  ref?: React.RefObject<HTMLButtonElement | null>;
};

export const IconButton = ({
  ref,
  children,
  onClick,
  disabled,
  colorPalette = 'gray',
  variant,
  _hover,
  ...props
}: IconButtonProps) => {
  return (
    <ChakraIconButton
      onClick={onClick}
      ref={ref}
      borderRadius="l2"
      colorPalette={colorPalette}
      variant={variant}
      // Тихая кнопка под курсором подсвечивается той же заливкой, что строка списка. Раньше
      // каждое место писало это само, и одно и то же значение ходило под двумя именами:
      // `bg.muted` в чате и `whiteAlpha.100` в блоге — это один цвет. Цвет иконки при
      // наведении остаётся за вызывающим, заливку он больше не задаёт.
      _hover={variant === 'ghost' ? { bg: 'bg.muted', ..._hover } : _hover}
      // Не настоящий `disabled`, а его вид плюс семантика: настоящий гасит события мыши, и
      // тултип «почему нельзя» на такой кнопке не показывается. Поэтому вид через
      // `data-disabled`, клик глушится, а для клавиатуры и читалки состояние объявляется явно:
      // раньше кнопка выглядела выключенной, но Tab на неё вставал и читалка звала её живой.
      {...(disabled && {
        ['data-disabled']: true,
        'aria-disabled': true,
        tabIndex: -1,
        onClick: (event) => event.preventDefault(),
      })}
      {...props}
    >
      {children}
    </ChakraIconButton>
  );
};
